import moment from 'moment'

const selectorValues = {
  NEW: 'NEW',
  NONE: 'NONE',
  NO_ROOM: 'NO_ROOM'
}

const defaultValues = {
  CHECKIN_DATE: moment().format('YYYY-MM-DD'),  // Today
  CHECKIN_TIME: '09:00',  // hh:mm format
  CHECKOUT_DATE: moment().add(1, 'days').format('YYYY-MM-DD'),  // Tomorrow
  CHECKOUT_TIME: '09:00', // hh:mm format
  NUMBER_OF_ROOMS: 1,
  NUMBER_OF_GUESTS: 2
}

export {
  selectorValues,
  defaultValues
}
